import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@sevensenders/component-library';

export default function StationNameCell({ value }) {
  if (!value) return null;

  return <Text inline={false}>{value.public_name}</Text>;
}

StationNameCell.propTypes = {
  value: PropTypes.shape({
    public_name: PropTypes.string.isRequired,
  }).isRequired,
};
